var React = require('react');

function Diamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.79312 134L165 0.64411L329.207 134L165 267.356L0.79312 134Z","stroke":"#3E4F19"}));
}

Diamond.defaultProps = {"width":"330","height":"268","viewBox":"0 0 330 268","fill":"none"};

module.exports = Diamond;

Diamond.default = Diamond;
